<template>
  <div class='text'>
    <p>{{data.card_observation[0].description}}</p>
    <amaze-userfile :userfile="data.card_observation[0].userfile" :key="data.card_observation[0].userfile.id">
    </amaze-userfile>
  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.text {
  font-size: 14px;
}
</style>
<script>
export default {
  props: ["data"],
  computed: {
    filepath() {
      console.log(process.env);
      return (
        process.env.VUE_APP_FILE_BASE + this.data.card_observation[0].userfile.full_url
      );
    }
  }
};
</script>
